import { Component, OnInit, OnDestroy, HostBinding, HostListener, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AdminPermitDetail } from '../../models/permit.model';
import { PermitV2Service } from '../../services/permits.abstract.service';

@Component({
    selector: 'app-permit-detail-page',
    templateUrl: './permit-detail-page.component.html',
    styleUrls: ['./permit-detail-page.component.scss'],
})
export class PermitDetailPageComponent implements OnInit, OnDestroy {
    @HostBinding('class.closing') closing = false;

    permit: AdminPermitDetail;
    loading = true;

    private permitId: string;
    private destroy$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private permitService: PermitV2Service,
        private elementRef: ElementRef,
    ) {}

    @HostListener('document:mousedown', ['$event'])
    onDocumentMousedown(event: MouseEvent): void {
        if (this.closing || this.loading) return;
        if (this.elementRef.nativeElement.contains(event.target as Node)) return;
        if ((event.target as HTMLElement).closest('.cdk-overlay-container')) return;
        this.close();
    }

    ngOnInit(): void {
        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            if (params['id']) {
                this.permitId = params['id'];
                this.closing = false;
                this.loadPermit(this.permitId);
            }
        });
    }

    loadPermit(id: string): void {
        this.loading = true;
        this.permitService
            .getPermitById(id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data: AdminPermitDetail) => {
                    this.permit = data;
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                },
            });
    }

    reload(): void {
        if (this.permitId) {
            this.loadPermit(this.permitId);
        }
    }

    refreshPermit(id: string): void {
        this.permitService
            .getPermitById(id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data: AdminPermitDetail) => {
                    this.permit = data;
                },
                error: () => {},
            });
    }

    onPermitUpdated(updated?: AdminPermitDetail): void {
        if (updated) {
            this.permit = updated;
        } else if (this.permitId) {
            this.refreshPermit(this.permitId);
        }
    }

    close(): void {
        this.closing = true;
        setTimeout(() => {
            this.router.navigate(['../..'], { relativeTo: this.route });
        }, 240);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
